/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

/* IMAGES */
import AboutUsImage from "assets/images/about-us.png";

const AboutUs = () => {
  return (
    <motion.div
      variants={animation}
      className="py-6 xl:py-12 lg:py-12"
      id="about"
    >
      <div className="container">
        <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20 items-center">
          <div className="col-span-1">
            <h2 className="text-2xl xl:text-3xl lg:text-3xl font-source font-bold text-black tracking-tight">
              Our Real Estate Certificate Program
            </h2>
            <div className="mt-5">
              <p className="text-base font-source font-regular text-greyText leading-relaxed">
                Our institution maintains its standing as one of the{" "}
                <span className="font-semibold text-black">
                  best real estate programs in California
                </span>{" "}
                because we deliver outstanding educational quality and student
                support.{" "}
                <span className="font-semibold text-black">
                  Real estate training courses
                </span>{" "}
                at our institution deliver customized learning opportunities
                that enable you to reach your goals while excelling
                professionally in the industry.
              </p>
              <p className="mt-5 text-base font-source font-regular text-greyText leading-relaxed">
                Our flagship offering is the One-Day In-Person{" "}
                <span className="font-semibold text-black">
                  Real Estate Training Course
                </span>
                , designed to provide you with all the essential knowledge
                required to pass the{" "}
                <span className="font-semibold text-black">
                  California Real Estate Exam
                </span>{" "}
                efficiently. This complete training program reflects our
                dedication to delivering premium{" "}
                <span className="font-semibold text-black">
                  real estate education programs
                </span>
                that teach practical skills and rely on comprehension instead of
                memorization.
              </p>
              <p className="mt-5 text-base font-source font-regular text-greyText leading-relaxed">
                This course stands out from other real estate training programs
                because it implements hands-on learning strategies that benefit
                those driven to get their license with holistic educational
                backing.
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <img
              src={AboutUsImage}
              className="w-full h-[30vh] xl:h-[50vh] lg:h-[50vh] object-cover rounded-xl shadow-md"
              alt="About DFA"
            />
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-5 xl:gap-5 lg:gap-5">
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <h5 className="text-lg font-source font-semibold text-black">
                Expert Instructors
              </h5>
              <p className="mt-1 text-base font-source font-normal text-greyText">
                Our faculty consists of experienced industry practitioners who
                bring their real estate expertise to teach you using practical
                industry scenarios.​
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <h5 className="text-lg font-source font-semibold text-black">
                Flexible Learning Options
              </h5>
              <p className="mt-1 text-base font-source font-normal text-greyText">
                We provide flexible learning options through offline self-paced
                courses, which let you advance your understanding at your own
                speed.​
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <h5 className="text-lg font-source font-semibold text-black">
                Comprehensive Support
              </h5>
              <p className="mt-1 text-base font-source font-normal text-greyText">
                Our instructors are accessible to deliver individual support,
                guidance, and a helpful knowledge base for you to succeed.​
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AboutUs;
